import { cookieRichtlinieDe } from './de/cookie-richtlinie';
import { datenschutzDe } from './de/datenschutz';
import { faqDe } from './de/faq';
import { impressumDe } from './de/impressum';
import { nutzungsbedingungenDe } from './de/nutzungsbedingungen';
import type { MarketingDocContent } from './types';

export const marketingDocsByPath: Record<string, MarketingDocContent> = {
  impressum: impressumDe,
  datenschutz: datenschutzDe,
  nutzungsbedingungen: nutzungsbedingungenDe,
  'cookie-richtlinie': cookieRichtlinieDe,
};

export function getMarketingDoc(path: string): MarketingDocContent | undefined {
  const slug = path.replace(/^\//, '').replace(/\/$/, '');
  return marketingDocsByPath[slug];
}

export { faqDe };
